/**
 * 组件开放数据源
 */
export const COUNT_DOWN_DATA_SOURCE = [
  {
    label: '年',
    keys: 'year'
  },
  {
    label: '月',
    keys: 'month'
  },
  {
    label: '日',
    keys: 'day'
  },
  {
    label: '时',
    keys: 'hour'
  },
  {
    label: '分',
    keys: 'minute'
  },
  {
    label: '秒',
    keys: 'second'
  },
  {
    label: '倒计时文本',
    keys: 'text'
  },
  {
    label: '倒计时结束',
    keys: 'isEnded'
  }
]

/**
 * 组件信息
 */
export const info = {
  name: 'xy-count-down', // 组件名
  type: 'component-plus', // 组件类型
  label: '倒计时', // 组件label
  icon: 'icon-xy-count-down', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 80 // 组件默认高度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  element: {
    type: Object,
    default: () => ({
      name: '',
      type: '',
      uuid: '',
      hiden: false,
      animations: [],
      style: {},
      data: {},
      languages: [],
      dataSource: null,
      events: []
    })
  },
  language: {
    type: String,
    default: 'en'
  },
  // 目标时间，支持13位时间戳或零时区时间字符串
  targetTime: { type: [String, Number], default: '' },
  // 是否展示倒计时文本
  showText: { type: Boolean, default: true },
  // 格式类型
  formatType: { type: String, default: 'HH:mm:ss' }
}

/** 倒计时格式类型选项 */
export const FORMAT_TYPE_OPTIONS = [
  { label: 'HH:mm:ss', value: 'HH:mm:ss' },
  { label: 'HH:mm', value: 'HH:mm' },
  { label: 'MM-DD', value: 'MM-DD' },
  { label: '年月日+时分秒', value: 'Y-M-D HH:mm:ss' }
]

/**
 * 组件开放数据源
 */
export const dataSource = COUNT_DOWN_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input',
    label: '目标时间',
    propKey: 'targetTime',
    isActivityData: true
  },
  {
    type: 'xy-form-switch',
    label: '展示文本',
    propKey: 'showText'
  },
  {
    type: 'xy-form-select',
    label: '格式类型',
    propKey: 'formatType',
    options: FORMAT_TYPE_OPTIONS
  }
]
